import { createTheme } from "@material-ui/core/styles";

/** Matches tab labels + form field labels; xs uses smaller type so labels stay on one line */
export const theme = createTheme({
    palette: {
        primary: {
            main: "#01a3e0",
            contrastText: "#ffffff",
        },
        secondary: {
            main: "#f7af2a",
            contrastText: "#1a1a1a",
        },
        /* text: {
            primary: "#01a3e0"
        } */
    },
    typography: {
        htmlFontSize: 11,
        button: {
            fontSize: "0.8375rem",
            fontWeight: 500,
            letterSpacing: "0.02857em",
            textTransform: "none",
            fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        },
        body2: {
            fontSize: "0.9rem",
        },
        caption: {
            fontSize: "0.78rem",
        },
    },
    shape: {
        borderRadius: 30
    },
    overrides: {
        MuiFilledInput: {
            root: {
                backgroundColor: "green"
            }
        },
        MuiTypography: {
            body2: {
                root: {
                    "@media (max-width: 599.95px)": {
                        fontSize: "0.88rem",
                    },
                    "@media (min-width:960px)": {
                        fontSize: "0.9rem",
                    },
                },
            },
            caption: {
                root: {
                    "@media (max-width: 599.95px)": {
                        fontSize: "0.76rem",
                    },
                    "@media (min-width:960px)": {
                        fontSize: "0.78rem",
                    },
                },
            },
        },
        MuiTab: {
            root: {
                textTransform: "none",
                fontWeight: 500,
                fontSize: "0.8375rem",
                letterSpacing: "0.02857em",
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                minHeight: 44,
                "@media (max-width: 599.95px)": {
                    fontSize: "0.85rem",
                },
                "@media (min-width:960px)": {
                    fontSize: "0.8625rem",
                    minHeight: 44,
                },
            },
        },
        MuiInputLabel: {
            outlined: {
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontSize: "0.9rem",
                fontWeight: 500,
                letterSpacing: "0.02857em",
                textTransform: "none",
                lineHeight: 1.2,
                "@media (min-width:960px)": {
                    fontSize: "0.9375rem",
                },
                "@media (max-width: 599.95px)": {
                    fontSize: "0.75rem",
                    letterSpacing: "0.02em",
                    lineHeight: 1.25,
                },
                "&:not(.MuiInputLabel-shrink)": {
                    transform: "translate(14px, 20px) scale(1)",
                    "@media (max-width: 599.95px)": {
                        transform: "translate(14px, 19px) scale(1)",
                    },
                },
                "&.MuiInputLabel-shrink": {
                    lineHeight: 1,
                    fontSize: "0.82rem",
                    "@media (max-width: 599.95px)": {
                        fontSize: "0.68rem",
                    },
                    "@media (min-width:960px)": {
                        fontSize: "0.84rem",
                    },
                },
            },
        },
        MuiOutlinedInput: {
            input: {
                fontSize: "0.9rem",
                "@media (max-width: 599.95px)": {
                    fontSize: "0.92rem",
                },
                "@media (min-width:960px)": {
                    fontSize: "0.975rem",
                },
            },
            root: {
                alignItems: "center",
            },
        },
        MuiFormHelperText: {
            root: {
                lineHeight: 1.35,
                "@media (max-width: 599.95px)": {
                    fontSize: "0.7rem",
                },
                "@media (min-width:960px)": {
                    fontSize: "0.82rem",
                },
            },
        },
        MuiTextField: {
            root: {
                maxWidth: "100%"
            }
        },
        MuiButton: {
            containedPrimary: {
                color: "#ffffff",
                "&:hover": {
                    color: "#ffffff",
                },
            },
            containedSecondary: {
                color: "#1a1a1a",
                "&:hover": {
                    color: "#1a1a1a",
                },
            },
            root: {
                textTransform: "none",
                padding: "10px",
                "@media (max-width: 599.95px)": {
                    fontSize: "0.84rem",
                },
                "@media (min-width:960px)": {
                    fontSize: "0.85rem",
                },
            },
        },
    },
    props: {
        MuiButton: {
            disableRipple: true,
            variant: "contained",
            color: "primary",
            fullWidth: true
        },
        MuiTextField: {
            variant: "outlined",
            fullWidth: true,
            margin: "normal",
            InputLabelProps: {
                //shrink: true
            }
        },
        MuiPaper: {
            elevation: 12
        },
        MuiCard: {
            elevation: 12
        }
    }
});